// To have fetch Promise reject on HTTP error statuses, i.e. on any non-2xx status,
// define a custom response handler
export const checkStatus = (response) => {
  if (response.status >= 200 && response.status < 300) {
    return response;
  } else {
    let error = new Error(response.statusText);
    error.response = response;
    throw error;
  }
};
